import React from 'react';
import PropTypes from 'prop-types';
import NavItem from './NavItem';
var RevenueNavBar = function RevenueNavBar(_ref) {
  var _ref$revenueNavBarIte = _ref.revenueNavBarItems,
    revenueNavBarItems = _ref$revenueNavBarIte === void 0 ? [] : _ref$revenueNavBarIte,
    locale = _ref.locale,
    closeMenu = _ref.closeMenu,
    isClub = _ref.isClub;
  var navItems = revenueNavBarItems.map(function (item) {
    return /*#__PURE__*/React.createElement(NavItem, {
      key: item.id,
      className: "header__nav-top__nav-item",
      closeMenu: closeMenu,
      navItem: item,
      isClub: isClub,
      locale: locale
    });
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "header__nav-top__nav-container__revenue"
  }, /*#__PURE__*/React.createElement("nav", {
    className: "header__nav-top__nav-items header__nav-top__nav-items--revenue",
    onMouseEnter: closeMenu,
    "aria-label": "Tertiary Navigation"
  }, /*#__PURE__*/React.createElement("ul", {
    "aria-label": "Tertiary Navigation"
  }, navItems)));
};
export default RevenueNavBar;
RevenueNavBar.propTypes = {
  closeMenu: PropTypes.func.isRequired,
  locale: PropTypes.string,
  isClub: PropTypes.bool,
  revenueNavBarItems: PropTypes.instanceOf(Array).isRequired
};